import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { getQlikAppId } from '../state/selectors/getQlikAppId';
import { LIGHT_GREY, DARK_GREY } from '../constants/colors';
import QlikContentHeader from './QlikContentHeader';
import QlikGrid from './QlikGrid';

const QlikContentAreaContainer = styled.div`
  height: 100%;
  flex: 1;
  background: ${LIGHT_GREY};
  padding-bottom: 30px;
`;

const ContentAreaMessageContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 30px;
`;

const ContentMessage = styled.h3`
  font-size: 28px;
  font-weight: bold;
  color: ${DARK_GREY};
`;

function QlikContentArea({ t, qlikAppId }) {
  return (
    <QlikContentAreaContainer>
      {qlikAppId ? (
        <React.Fragment>
          <QlikContentHeader />
          <QlikGrid />
        </React.Fragment>
      ) : (
        <ContentAreaMessageContainer>
          <ContentMessage id="WelcomeMessage.SelectionText">
            {t('ContentArea.SelectMessage')}
          </ContentMessage>
        </ContentAreaMessageContainer>
      )}
    </QlikContentAreaContainer>
  );
}

QlikContentArea.propTypes = {
  t: PropTypes.func.isRequired, // supplied from withTranslation
  qlikAppId: PropTypes.string.isRequired, // supplied from Redux
};

const mapStateToProps = state => ({
  qlikAppId: getQlikAppId(state),
});

const TranslatedComponent = withTranslation()(QlikContentArea);

export default connect(mapStateToProps)(TranslatedComponent);
